import React from 'react';

export function getTalkTime() {
    const currentNow = new Date();

    let hi = currentNow.getHours();
    let mm = currentNow.getMinutes();
    let ampm = '오전'
    if (hi > 11) {
        ampm = '오후'
        if (hi > 12) {
            hi = hi - 12
        }
    }

    if (mm < 10) mm = '0' + mm
    // console.info(mm.length)

    return ampm + ' ' + hi + ':' + mm
}

export function nl2br(text) {
    //text = '[' + text + ']'
    if (text === undefined || text === null) return text
    let ret = text.replace(/(?:\r\n|\r|\n)/g, '<br />')
    ret = ret.replace(/(?:\\r\\n|\\r|\\n)/g, '<br />')
    
    return ret
}

export function nl2brElement(str) {
    if (!str) return null
  
    const lines = str.split('\n')
  
    if (lines.length === 0) {
      return str
    }
  
    return lines.map((line, index) => (
      React.createElement('span', {
        key: index,
      }, line, React.createElement('br'))
    ))
  }

export function openUrl(url, target, isApp) {
    console.log(isApp)
    if (isApp) {
        //url을 검사하자. 일단 URL중 .pdf만 검사
        let type = "link"
        if (url.indexOf(".pdf") > -1)  type = "file"
        window.openUrl(type, url)
    } else {
        const popWin = window.open(url, target)
        popWin.focus()
    }
}

export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        expires = "; expires=" + days.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

//SSO상태 및 returnUrl을 전달받아 인증페이지 리다이렉트 필요여부 판별
export function redirectSso(data,fromAdvisor){
    const returnUrl = data.redirectUrl
    let finalRedirectUrl = returnUrl.substring(0,returnUrl.indexOf('?')); 
    let queryStr = returnUrl.substring(returnUrl.indexOf('?') +1 , returnUrl.length)
    let rUrlSearchParams = new URLSearchParams(queryStr)
    rUrlSearchParams.set("returnURL", window.location.origin + window.location.pathname + window.location.search)
    rUrlSearchParams.delete("nrkey")
    rUrlSearchParams.delete("nrval")
    finalRedirectUrl += '?' +  rUrlSearchParams.toString();
    
    if(data.needRedirect != null && data.needRedirect){
      if(data.authStatus === 'SSOFirstAccess'){
        if(!fromAdvisor){ //웹브라우저인 경우
          //- submit으로 수정
          console.log('redirect activate - submit("'+ finalRedirectUrl + '")')
          let frm = document.createElement("form");
          let input1 = document.createElement('input');
          input1.setAttribute("type", "hidden");
          input1.setAttribute("name", "returnURL");
          input1.setAttribute("value", finalRedirectUrl);
          frm.appendChild(input1);
          
          let input2 = document.createElement('input');
          input2.setAttribute("type", "hidden");
          input2.setAttribute("name", "ssosite");
          //input2.setAttribute("value", "chat::chat.cau.ac.kr"); //
          input2.setAttribute("value", "chat.cau.ac.kr_domain::chat.cau.ac.kr_domain"); //2023.04.04 넷츠 양석우 부장님으로부터 전달받은 ssosite설정값 
          frm.appendChild(input2);
      
          frm.setAttribute("method", "GET");
          frm.setAttribute("action", "https://sso4.cau.ac.kr/sso/ssoService.do");
          document.body.appendChild(frm);
          frm.submit();
        }
      }
    }
  }